import type { PaymentMethod as StripePaymentMethod } from '@stripe/stripe-js';

export type GooglePayAuthMethod = 'CRYPTOGRAM_3DS' | 'PAN_ONLY' | 'unknown';

type AdyenGooglePayAuthorizedData = {
  authorizedEvent?: {
    paymentMethodData?: {
      info?: {
        assuranceDetails?: {
          cardHolderAuthenticated?: boolean;
        };
      };
    };
  };
};

export const adyenGooglePayAuthMethod = (data?: AdyenGooglePayAuthorizedData): GooglePayAuthMethod => {
  const cardHolderAuthenticated =
    data?.authorizedEvent?.paymentMethodData?.info?.assuranceDetails?.cardHolderAuthenticated;
  if (cardHolderAuthenticated === true) return 'CRYPTOGRAM_3DS';
  if (cardHolderAuthenticated === false) return 'PAN_ONLY';
  return 'unknown';
};

export const stripeGooglePayAuthMethod = (paymentMethod?: StripePaymentMethod): GooglePayAuthMethod => {
  const wallet = paymentMethod?.card?.wallet;
  if (wallet?.type !== 'google_pay') return 'unknown';
  return wallet.dynamic_last4 ? 'CRYPTOGRAM_3DS' : 'PAN_ONLY';
};
